<template>
  <div class="item-box-430" :class="{ downloadSettlement: download }">
    <div v-if="isShowCard" class="org">
      <div class="title">{{ billPlatfromMode==='3'?'结算信息':'机构收款信息' }}</div>
      <!-- <div><span class="label">收款方：</span>{{ bankData.cardCustName }}</div>
      <div><span class="label">收款账户：</span>{{ bankData.cardNo }}</div>
      <div><span class="label">开户行：</span>{{ bankData.openBankName }}</div> -->
      <div><span class="label">收款方：</span></div>
      <div><span class="label">收款账户：</span></div>
      <div><span class="label">开户行：</span></div>
    </div>
    <div v-if="tableType == 1" class="row row-1">
      <div class="left">
        <div class="box">
          <p style="height: 16px">(签章处)</p>
          <p class="org">{{ detailsData.data.orgName }}</p>
          <p class="org">负责人签字：</p>
          <p class="time"><span>年</span><span>月</span><span>日</span></p>
        </div>
      </div>
      <div class="right">
        <div class="box">
          <p style="height: 16px"></p>
          <p class="org">{{ adminName }}</p>
          <p class="org">负责人签字：</p>
          <p class="time"><span>年</span><span>月</span><span>日</span></p>
        </div>
      </div>
    </div>
    <div v-if="tableType == 2" class="row row-2">
      <p class="check-user">
        <span>平台审核人:</span>
        <span>学校审核人：</span>
      </p>
      <div class="check-other">
        <p style="padding-right: 32px">(签章处)</p>
        <p class="time"><span>年</span><span>月</span><span>日</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import { getColumn } from '../data/SettlementDetailsTable';
export default {
  inject: ['detailsData', 'tableType', 'type'],
  beforeRouteEnter() {

  },
  props: {
    bankData: {
      type: Object,
      default: () => { }
    },
    download: {
      type: Boolean,
      default: false
    },
    bankId: {
      type: String,
      default: ''
    },
    billPlatfromMode: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      portOrg: localStorage.getItem('portOrg')
      // tableType: 1: 运营平台 - 机构端->机构 2:运营平台 - 学校端 ->学校 3:教育局

    };
  },
  computed: {
    adminName() {
      // return this.detailsData.data.bankId == 1 ? '广州宏途数字科技有限公司' : '广州宏兔兔数字科技有限公司';
      return this.portOrg == 0 && this.bankId == '10002' && (this.billPlatfromMode === '1' || this.billPlatfromMode === '3') ? '广州宏兔兔数字科技有限公司' : this.detailsData.settlementSheetOrgName;
    },
    isShowCard() {
      return false;
      // 教育局、机构、运营 && 不是 教育局审批单 && 不是学校类型表格
      // return this.detailsData && [0, 1, 3].includes(Number(this.detailsData.portOrg)) && this.type != 1 && this.tableType != 2;
    }
  },
  watch: {
    bankData: {
      handler(newVal) {
        console.log(newVal, '拿到的数据0----');
      },
      deep: true
    }
  },
  created() {

  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common';

.org {
  margin-bottom: 64px;
  .title {
    font-weight: bold;
    margin-bottom: 16px;
    padding-left: 0px;
  }
  > div {
    margin-bottom: 16px;
    padding-left: 30px;
    span {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
  }
}

.row-1 {
  justify-content: space-around;
  display: flex;
  > div {
    display: flex;

    .box {
      p {
        margin-bottom: 32px;
      }
      .time {
        text-align: right;
        span {
          margin-left: 32px;
        }
      }
    }
  }
}
.row-2 {
  .check-user {
    display: flex;
    // justify-content: center;
    justify-content: space-around;
    margin-bottom: 32px;
    span:last-child {
      // margin-left: 320px;
    }
  }
  .check-other {
    text-align: right;
    padding-right: 200px;
    .time {
      padding-top: 32px;
      span {
        margin-left: 32px;
      }
    }
  }
}
/* 打印样式 */
$fontSize18: 18px;
.downloadSettlement {
  .title {
    font-size: $fontSize18;
  }
  div {
    font-size: $fontSize18;
    span {
      font-size: $fontSize18;
    }
  }
  .label {
    width: 120px !important;
  }
  p {
    font-size: $fontSize18;
    span {
      font-size: $fontSize18;
    }
  }
}
</style>
